import * as React from "react"
import Svg, {
  Defs,
  ClipPath,
  Path,
  Mask,
  G,
  LinearGradient,
  Stop,
  Use,
} from "react-native-svg"
/* SVGR has dropped some elements not supported by react-native-svg: filter */

const SvgComponent = (props) => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={"100%"}
    height={"100%"}
    viewBox="0 0 425 349"
    {...props}
  >
    <Defs>
      <ClipPath id="b">
        <Path d="M0 0h425v349H0z" />
      </ClipPath>
      <ClipPath id="c">
        <Path d="M0 0h425v349H0z" />
      </ClipPath>
      <ClipPath id="d">
        <Path d="M0 0h425v349H0z" />
      </ClipPath>
      <ClipPath id="e">
        <Path d="M0 0h425v349H0z" />
      </ClipPath>
      <ClipPath id="f">
        <Path d="M0 0h425v349H0z" />
      </ClipPath>
      <ClipPath id="g">
        <Path d="M0 0h425v349H0z" />
      </ClipPath>
      <ClipPath id="h">
        <Path d="M0 0h425v349H0z" />
      </ClipPath>
      <ClipPath id="i">
        <Path d="M0 0h425v349H0z" />
      </ClipPath>
      <ClipPath id="j">
        <Path d="M0 0h425v349H0z" />
      </ClipPath>
      <ClipPath id="k">
        <Path d="M0 0h425v349H0z" />
      </ClipPath>
      <ClipPath id="l">
        <Path d="M0 0h425v349H0z" />
      </ClipPath>
      <ClipPath id="m">
        <Path d="M0 0h425v349H0z" />
      </ClipPath>
      <ClipPath id="n">
        <Path d="M0 0h425v349H0z" />
      </ClipPath>
      <ClipPath id="o">
        <Path d="M0 0h425v349H0z" />
      </ClipPath>
      <ClipPath id="p">
        <Path d="M0 0h425v349H0z" />
      </ClipPath>
      <ClipPath id="q">
        <Path d="M0 0h425v349H0z" />
      </ClipPath>
      <ClipPath id="r">
        <Path d="M0 0h425v349H0z" />
      </ClipPath>
      <ClipPath id="s">
        <Path d="M0 0h425v349H0z" />
      </ClipPath>
      <ClipPath id="t">
        <Path d="M0 0h425v349H0z" />
      </ClipPath>
      <ClipPath id="u">
        <Path d="M0 0h425v349H0z" />
      </ClipPath>
      <ClipPath id="v">
        <Path d="M0 0h425v349H0z" />
      </ClipPath>
      <ClipPath id="w">
        <Path d="M0 0h425v349H0z" />
      </ClipPath>
      <ClipPath id="x">
        <Path d="M0 0h425v349H0z" />
      </ClipPath>
      <ClipPath id="y">
        <Path d="M0 0h425v349H0z" />
      </ClipPath>
      <ClipPath id="z">
        <Path d="M0 0h425v349H0z" />
      </ClipPath>
      <ClipPath id="A">
        <Path d="M0 0h425v349H0z" />
      </ClipPath>
      <ClipPath id="B">
        <Path d="M0 0h425v349H0z" />
      </ClipPath>
      <ClipPath id="C">
        <Path d="M0 0h425v349H0z" />
      </ClipPath>
      <ClipPath id="D">
        <Path d="M0 0h425v349H0z" />
      </ClipPath>
      <ClipPath id="E">
        <Path d="M0 0h425v349H0z" />
      </ClipPath>
      <Mask id="G">
        <G filter="url(#a)">
          <Path
            style={{
              fill: "#000",
              fillOpacity: 0.101961,
              stroke: "none",
            }}
            d="M0 0h425v349H0z"
          />
        </G>
      </Mask>
      <Mask id="J">
        <G filter="url(#a)">
          <Path
            style={{
              fill: "#000",
              fillOpacity: 0.101961,
              stroke: "none",
            }}
            d="M0 0h425v349H0z"
          />
        </G>
      </Mask>
      <Mask id="L">
        <G filter="url(#a)">
          <Path
            style={{
              fill: "#000",
              fillOpacity: 0.0509804,
              stroke: "none",
            }}
            d="M0 0h425v349H0z"
          />
        </G>
      </Mask>
      <Mask id="N">
        <G filter="url(#a)">
          <Path
            style={{
              fill: "#000",
              fillOpacity: 0.101961,
              stroke: "none",
            }}
            d="M0 0h425v349H0z"
          />
        </G>
      </Mask>
      <Mask id="P">
        <G filter="url(#a)">
          <Path
            style={{
              fill: "#000",
              fillOpacity: 0.101961,
              stroke: "none",
            }}
            d="M0 0h425v349H0z"
          />
        </G>
      </Mask>
      <Mask id="R">
        <G filter="url(#a)">
          <Path
            style={{
              fill: "#000",
              fillOpacity: 0.101961,
              stroke: "none",
            }}
            d="M0 0h425v349H0z"
          />
        </G>
      </Mask>
      <Mask id="T">
        <G filter="url(#a)">
          <Path
            style={{
              fill: "#000",
              fillOpacity: 0.101961,
              stroke: "none",
            }}
            d="M0 0h425v349H0z"
          />
        </G>
      </Mask>
      <Mask id="V">
        <G filter="url(#a)">
          <Path
            style={{
              fill: "#000",
              fillOpacity: 0.0509804,
              stroke: "none",
            }}
            d="M0 0h425v349H0z"
          />
        </G>
      </Mask>
      <Mask id="X">
        <G filter="url(#a)">
          <Path
            style={{
              fill: "#000",
              fillOpacity: 0.0509804,
              stroke: "none",
            }}
            d="M0 0h425v349H0z"
          />
        </G>
      </Mask>
      <Mask id="aa">
        <G filter="url(#a)">
          <Path
            style={{
              fill: "#000",
              fillOpacity: 0.0509804,
              stroke: "none",
            }}
            d="M0 0h425v349H0z"
          />
        </G>
      </Mask>
      <Mask id="ac">
        <G filter="url(#a)">
          <Path
            style={{
              fill: "#000",
              fillOpacity: 0.101961,
              stroke: "none",
            }}
            d="M0 0h425v349H0z"
          />
        </G>
      </Mask>
      <Mask id="ae">
        <G filter="url(#a)">
          <Path
            style={{
              fill: "#000",
              fillOpacity: 0.101961,
              stroke: "none",
            }}
            d="M0 0h425v349H0z"
          />
        </G>
      </Mask>
      <Mask id="ag">
        <G filter="url(#a)">
          <Path
            style={{
              fill: "#000",
              fillOpacity: 0.101961,
              stroke: "none",
            }}
            d="M0 0h425v349H0z"
          />
        </G>
      </Mask>
      <Mask id="ai">
        <G filter="url(#a)">
          <Path
            style={{
              fill: "#000",
              fillOpacity: 0.101961,
              stroke: "none",
            }}
            d="M0 0h425v349H0z"
          />
        </G>
      </Mask>
      <Mask id="ak">
        <G filter="url(#a)">
          <Path
            style={{
              fill: "#000",
              fillOpacity: 0.101961,
              stroke: "none",
            }}
            d="M0 0h425v349H0z"
          />
        </G>
      </Mask>
      <Mask id="am">
        <G filter="url(#a)">
          <Path
            style={{
              fill: "#000",
              fillOpacity: 0.101961,
              stroke: "none",
            }}
            d="M0 0h425v349H0z"
          />
        </G>
      </Mask>
      <Mask id="ao">
        <G filter="url(#a)">
          <Path
            style={{
              fill: "#000",
              fillOpacity: 0.101961,
              stroke: "none",
            }}
            d="M0 0h425v349H0z"
          />
        </G>
      </Mask>
      <Mask id="aq">
        <G filter="url(#a)">
          <Path
            style={{
              fill: "#000",
              fillOpacity: 0.101961,
              stroke: "none",
            }}
            d="M0 0h425v349H0z"
          />
        </G>
      </Mask>
      <Mask id="as">
        <G filter="url(#a)">
          <Path
            style={{
              fill: "#000",
              fillOpacity: 0.101961,
              stroke: "none",
            }}
            d="M0 0h425v349H0z"
          />
        </G>
      </Mask>
      <Mask id="au">
        <G filter="url(#a)">
          <Path
            style={{
              fill: "#000",
              fillOpacity: 0.101961,
              stroke: "none",
            }}
            d="M0 0h425v349H0z"
          />
        </G>
      </Mask>
      <Mask id="aw">
        <G filter="url(#a)">
          <Path
            style={{
              fill: "#000",
              fillOpacity: 0.101961,
              stroke: "none",
            }}
            d="M0 0h425v349H0z"
          />
        </G>
      </Mask>
      <Mask id="ay">
        <G filter="url(#a)">
          <Path
            style={{
              fill: "#000",
              fillOpacity: 0.101961,
              stroke: "none",
            }}
            d="M0 0h425v349H0z"
          />
        </G>
      </Mask>
      <Mask id="aA">
        <G filter="url(#a)">
          <Path
            style={{
              fill: "#000",
              fillOpacity: 0.0509804,
              stroke: "none",
            }}
            d="M0 0h425v349H0z"
          />
        </G>
      </Mask>
      <Mask id="aC">
        <G filter="url(#a)">
          <Path
            style={{
              fill: "#000",
              fillOpacity: 0.0509804,
              stroke: "none",
            }}
            d="M0 0h425v349H0z"
          />
        </G>
      </Mask>
      <Mask id="aE">
        <G filter="url(#a)">
          <Path
            style={{
              fill: "#000",
              fillOpacity: 0.101961,
              stroke: "none",
            }}
            d="M0 0h425v349H0z"
          />
        </G>
      </Mask>
      <Mask id="aG">
        <G filter="url(#a)">
          <Path
            style={{
              fill: "#000",
              fillOpacity: 0.0509804,
              stroke: "none",
            }}
            d="M0 0h425v349H0z"
          />
        </G>
      </Mask>
      <Mask id="aI">
        <G filter="url(#a)">
          <Path
            style={{
              fill: "#000",
              fillOpacity: 0.101961,
              stroke: "none",
            }}
            d="M0 0h425v349H0z"
          />
        </G>
      </Mask>
      <Mask id="aK">
        <G filter="url(#a)">
          <Path
            style={{
              fill: "#000",
              fillOpacity: 0.101961,
              stroke: "none",
            }}
            d="M0 0h425v349H0z"
          />
        </G>
      </Mask>
      <Mask id="aM">
        <G filter="url(#a)">
          <Path
            style={{
              fill: "#000",
              fillOpacity: 0.2,
              stroke: "none",
            }}
            d="M0 0h425v349H0z"
          />
        </G>
      </Mask>
      <Mask id="aO">
        <G filter="url(#a)">
          <Path
            style={{
              fill: "#000",
              fillOpacity: 0.2,
              stroke: "none",
            }}
            d="M0 0h425v349H0z"
          />
        </G>
      </Mask>
      <G id="F" clipPath="url(#b)">
        <Path
          style={{
            stroke: "none",
            fillRule: "nonzero",
            fill: "#e417c3",
            fillOpacity: 1,
          }}
          d="M23.93 179.145c1.195 13.449 8.82 25.625 13.472 38.433a91.145 91.145 0 0 1 1.774 56.574c-1.11 3.817-2.477 7.645-2.477 11.555 0 13.473 15.348 22.418 29.293 28.363a533.661 533.661 0 0 0 110.262 33.325c12.375 2.34 27.832 3.347 35.664-5.446 3.762-4.222 4.668-9.738 7.43-14.476 7.039-12.082 24.164-16.774 39.539-19.465a482.866 482.866 0 0 1 56.031-6.45c18.914-1.062 40.387-1.992 52.922-14.41 7.965-7.898 10.281-18.793 10.601-29.082 1.04-33.761-15.09-70.296 5.614-99.535 8.68-12.261 22.851-21.219 31.465-33.515 12.472-17.82 11.394-40.454 2.953-59.446-8.446-18.992-23.403-35.14-38.145-50.965-4.875-5.23-10.078-10.671-17.398-13.097-7.618-2.528-16.258-1.367-24.426-.172-37.164 5.426-75.738 11.336-106.906 29.973-15.477 9.257-28.407 21.261-42.22 32.3-29.831 23.852-64.386 45.883-103.776 55.301-32 7.653-64.547 28.297-61.672 60.235Zm0 0"
        />
      </G>
      <G id="I" clipPath="url(#c)">
        <Path
          style={{
            stroke: "none",
            fillRule: "nonzero",
            fill: "#000",
            fillOpacity: 1,
          }}
          d="M233.191 201.91a4.414 4.414 0 0 0-1.554-.555c-10.555-1.433-39.5 23.31-39.5 23.31l2.07 52.233c-1.887 2.184-4.316 3.016-6.773 3.11 3.734.87 8.054.797 11.023-2.656l-2.086-52.247s24.754-21.144 36.82-23.195ZM294.953 287.047c-1.058-4.379-17.777-36.77-20.473-37.363-2.69-.594-2.148-48.563-2.148-48.563l3.91-36.594-4.234-.453-3.91 36.594s-.543 47.965 2.148 48.559c2.695.593 19.414 32.972 20.477 37.367.714 2.976-5.977 4.597-10.403 5.336l.555.957s15.14-1.446 14.078-5.84Zm0 0"
        />
      </G>
      <G id="K" clipPath="url(#d)">
        <Path
          style={{
            stroke: "none",
            fillRule: "nonzero",
            fill: "#000",
            fillOpacity: 1,
          }}
          d="M256.402 92.664s-10.101 5.648-12.093 18.59c-1.993 12.941-3.63-.399-3.63-.399s-5.784 5.497-7.566 5.004c-1.781-.496-1.465 19.418 8.051 21.97 9.516 2.546 17.031-39.169 17.031-39.169Zm0 0"
        />
      </G>
      <G id="M" clipPath="url(#e)">
        <Path
          style={{
            stroke: "none",
            fillRule: "nonzero",
            fill: "#000",
            fillOpacity: 1,
          }}
          d="M292.727 81.867c-1.434 2.176-1.493 4.64-.797 7.098a16.729 16.729 0 0 1-16.618-8.168c.317-1.656.528-3.328.63-5.008 0 0 22.257-2.207 16.785 6.078Zm0 0"
        />
      </G>
      <G id="O" clipPath="url(#f)">
        <Path
          style={{
            stroke: "none",
            fillRule: "nonzero",
            fill: "#000",
            fillOpacity: 1,
          }}
          d="m275.64 164.465-.574 5.351c-4.87-1.304-38.289-9.96-45.363-4.757a8.34 8.34 0 0 1-1.058.671 30.511 30.511 0 0 0 2.851-5.976Zm0 0"
        />
      </G>
      <G id="Q" clipPath="url(#g)">
        <Path
          style={{
            stroke: "none",
            fillRule: "nonzero",
            fill: "#000",
            fillOpacity: 1,
          }}
          d="M292.82 64.262c.38-.707.102-1.625-.437-2.223a5.927 5.927 0 0 0-2.028-1.277l-3.636-1.653a12.608 12.608 0 0 1-3.383-1.992c-.973-.883-1.672-2.16-1.543-3.465.133-1.3 1.02-2.351 1.953-3.238.73-.7 1.512-1.348 2.34-1.934a5.071 5.071 0 0 1 2.273-1.042c1.82-.215 3.375 1.277 5.157 1.699 2.691.629 5.273-1.235 7.968-1.805 3.22-.687 6.696.578 8.989 2.934 2.293 2.355 3.457 5.687 3.504 8.976.03 1.75-.227 3.586.437 5.18.3.746.797 1.406 1.055 2.168.27.969.351 1.98.246 2.98a22.655 22.655 0 0 1-.418 4.14c-.965 4.196-4.277 7.54-8.07 9.563-2.23 1.196-4.668 2.024-6.707 3.52a10.06 10.06 0 0 1-1.594 1.086 3.652 3.652 0 0 1-3.563-.305 2.6 2.6 0 0 1-1.191-2.152c.039-.852.613-1.574 1.055-2.305 1.152-1.898 1.425-4.594-.114-6.207-.672-.703-1.593-1.117-2.258-1.84-1.066-1.195-1.195-2.914-1.23-4.507-.105-2.977-.18-6.079 1.063-8.766"
        />
      </G>
      <G id="S" clipPath="url(#h)">
        <Path
          style={{
            stroke: "none",
            fillRule: "nonzero",
            fill: "#000",
            fillOpacity: 1,
          }}
          d="M304.453 129.832c-2.45 2.832-5.973 7.055-10.258 12.668a67.793 67.793 0 0 1-6.894 4.55s-6.203 3.614-9.485 11.688c-13.054.688-28.832-25.265-28.832-25.265l10.332-10.825 17.614 12.59 5.738-12.293a20.71 20.71 0 0 1 16.758-11.863l.273-.023c3.668-.336 5.785 1.855 7.004 4.629a13.436 13.436 0 0 1-2.25 14.144Zm0 0"
        />
      </G>
      <G id="U" clipPath="url(#i)">
        <Path
          style={{
            stroke: "none",
            fillRule: "nonzero",
            fill: "#000",
            fillOpacity: 1,
          }}
          d="M271.715 83.898s-1.3 4.325 4.668 5.098c.644.082 1.285.2 1.918.344 1.777.426 3.586.7 5.41.82a35.408 35.408 0 0 1-2.688-.527 18.661 18.661 0 0 0-1.921-.348c-5.973-.773-4.668-5.094-4.668-5.094a21.89 21.89 0 0 0-3.567-.457c.293.055.574.106.848.164ZM297.34 93.066l-5.422-3.636a4.69 4.69 0 0 1-1.328.64l4.031 2.707s16.785 14.641 13.117 28.93c-2.226 8.676-10.285 16.043-16.277 20.504a66.685 66.685 0 0 1-6.895 4.547s-6.203 3.613-9.484 11.691a27.358 27.358 0 0 0-1.957 9.285c1.7.434 2.7.711 2.7.711a27.403 27.403 0 0 1 1.991-9.722c3.282-8.075 9.485-11.688 9.485-11.688a67.793 67.793 0 0 0 6.894-4.55c5.973-4.454 14.047-11.829 16.274-20.5 3.656-14.278-13.13-28.919-13.13-28.919ZM227.145 163.254l-.286.2c.153 1.257.996 1.57 3.008.089 2.39-1.742 7.723-1.926 13.942-1.348-7.356-.89-13.95-.933-16.664 1.059Zm0 0"
        />
      </G>
      <G id="W" clipPath="url(#j)">
        <Path
          style={{
            stroke: "none",
            fillRule: "nonzero",
            fill: "#000",
            fillOpacity: 1,
          }}
          d="M237.867 139.191s3.082 7.965 7.356 10.856c4.273 2.887 9.867 7.785 9.867 7.785"
        />
      </G>
      <G id="Z" clipPath="url(#k)">
        <Path
          style={{
            stroke: "none",
            fillRule: "nonzero",
            fill: "#000",
            fillOpacity: 1,
          }}
          d="m231.488 133.617 6.13.656-8.345 78.094-6.128-.656Zm0 0"
        />
      </G>
      <G id="ab" clipPath="url(#l)">
        <Path
          style={{
            stroke: "none",
            fillRule: "nonzero",
            fill: "#000",
            fillOpacity: 1,
          }}
          d="m224.676 136.16.344-3.23 12.582 1.343-.344 3.23Zm0 0"
        />
      </G>
      <G id="ad" clipPath="url(#m)">
        <Path
          style={{
            stroke: "none",
            fillRule: "nonzero",
            fill: "#000",
            fillOpacity: 1,
          }}
          d="m228.129 131.305.379-3.551 7.422.793-.38 3.55Zm0 0"
        />
      </G>
      <G id="af" clipPath="url(#n)">
        <Path
          style={{
            fill: "none",
            strokeWidth: 1,
            strokeLinecap: "butt",
            strokeLinejoin: "miter",
            stroke: "#000",
            strokeOpacity: 1,
            strokeMiterlimit: 10,
          }}
          d="M471.384 771.303s16.29-22.816 15.476-39.102c-.814-16.295 3.844-56.054 3.844-56.054"
          transform="matrix(.39831 0 0 .3984 -26.544 -4.773)"
        />
      </G>
      <G id="ah" clipPath="url(#o)">
        <Path
          style={{
            fill: "none",
            strokeWidth: 1,
            strokeLinecap: "butt",
            strokeLinejoin: "miter",
            stroke: "#000",
            strokeOpacity: 1,
            strokeMiterlimit: 10,
          }}
          d="M530.854 710.2s16.29-30.14 14.651-46.426c0 0 17.113-31.003 30.147-28.513"
          transform="matrix(.39831 0 0 .3984 -26.544 -4.773)"
        />
      </G>
      <G id="aj" clipPath="url(#p)">
        <Path
          style={{
            fill: "none",
            strokeWidth: 1,
            strokeLinecap: "butt",
            strokeLinejoin: "miter",
            stroke: "#000",
            strokeOpacity: 1,
            strokeMiterlimit: 10,
          }}
          d="M620.46 624.672s44.798-16.295 47.25-29.336"
          transform="matrix(.39831 0 0 .3984 -26.544 -4.773)"
        />
      </G>
      <G id="al" clipPath="url(#q)">
        <Path
          style={{
            fill: "none",
            strokeWidth: 1,
            strokeLinecap: "butt",
            strokeLinejoin: "miter",
            stroke: "#000",
            strokeOpacity: 1,
            strokeMiterlimit: 10,
          }}
          d="M636.75 662.136S684 640.997 684 635.261h23.625s34.206 44.798 30.136 64.359"
          transform="matrix(.39831 0 0 .3984 -26.544 -4.773)"
        />
      </G>
      <G id="an" clipPath="url(#r)">
        <Path
          style={{
            fill: "none",
            strokeWidth: 1,
            strokeLinecap: "butt",
            strokeLinejoin: "miter",
            stroke: "#000",
            strokeOpacity: 1,
            strokeMiterlimit: 10,
          }}
          d="M692.15 694.718s-45.623-3.256-61.912 9.785c-16.29 13.04-45.622 19.55-45.622 19.55s-17.104 36.66-23.616 43.18c-6.512 6.521-17.113 29.327-17.113 29.327"
          transform="matrix(.39831 0 0 .3984 -26.544 -4.773)"
        />
      </G>
      <G id="ap" clipPath="url(#s)">
        <Path
          style={{
            fill: "none",
            strokeWidth: 1,
            strokeLinecap: "butt",
            strokeLinejoin: "miter",
            stroke: "#000",
            strokeOpacity: 1,
            strokeMiterlimit: 10,
          }}
          d="M692.15 737.898s4.854 17.1 11.405 26.885c6.54 9.775 16.29 44.798 16.29 44.798"
          transform="matrix(.39831 0 0 .3984 -26.544 -4.773)"
        />
      </G>
      <G id="ar" clipPath="url(#t)">
        <Path
          style={{
            fill: "none",
            strokeWidth: 1,
            strokeLinecap: "butt",
            strokeLinejoin: "miter",
            stroke: "#000",
            strokeOpacity: 1,
            strokeMiterlimit: 10,
          }}
          d="M768.722 787.589s10.337 28.767 19.428 29.002"
          transform="matrix(.39831 0 0 .3984 -26.544 -4.773)"
        />
      </G>
      <G id="at" clipPath="url(#u)">
        <Path
          style={{
            fill: "none",
            strokeWidth: 1,
            strokeLinecap: "butt",
            strokeLinejoin: "miter",
            stroke: "#000",
            strokeOpacity: 1,
            strokeMiterlimit: 10,
          }}
          d="M701.005 664.097s26.851 7.266 38.08 24.855c11.24 17.59 45.573 33.552 45.573 33.552"
          transform="matrix(.39831 0 0 .3984 -26.544 -4.773)"
        />
      </G>
      <G id="av" clipPath="url(#v)">
        <Path
          style={{
            fill: "none",
            strokeWidth: 1,
            strokeLinecap: "butt",
            strokeLinejoin: "miter",
            stroke: "#000",
            strokeOpacity: 1,
            strokeMiterlimit: 10,
          }}
          d="M712.508 577.423s0 37.464 10.592 37.464 34.217 4.108 34.217 4.108"
          transform="matrix(.39831 0 0 .3984 -26.544 -4.773)"
        />
      </G>
      <G id="ax" clipPath="url(#w)">
        <Path
          style={{
            fill: "none",
            strokeWidth: 1,
            strokeLinecap: "butt",
            strokeLinejoin: "miter",
            stroke: "#000",
            strokeOpacity: 1,
            strokeMiterlimit: 10,
          }}
          d="M660.64 532.948s-2.707 64.731-16.555 81.478"
          transform="matrix(.39831 0 0 .3984 -26.544 -4.773)"
        />
      </G>
      <G id="az" clipPath="url(#x)">
        <Path
          style={{
            stroke: "none",
            fillRule: "nonzero",
            fill: "#000",
            fillOpacity: 1,
          }}
          d="m296.52 276.875-7.786-26.613c-7.14-10.387-14.277-8.766-14.277-8.766-4.219-2.594-7.137-17.187-7.137-17.187-1.3-15.907-30.5-15.579-30.5-15.579l-2.27-3.894c-2.874-.574-6.144-.61-9.425-.34.797.078 1.55.191 2.29.34l2.269 3.894s29.203-.324 30.5 15.579c0 0 2.918 14.605 7.136 17.203 0 0 7.137-1.621 14.274 8.765l7.789 26.614s20.441 19.129 14.273 36.66c0 0-4.16 5.922-21.48 6.637 23.347.855 28.62-6.637 28.62-6.637 6.165-17.531-14.276-36.676-14.276-36.676ZM182.305 312.25a151.63 151.63 0 0 1-20.79 2.254c8.126.308 16.583-.567 22.032-1.32a39.64 39.64 0 0 1-1.242-.934ZM252.39 317.441a133.227 133.227 0 0 1-30.64 4.848c14.957.54 29.125-2.574 34.965-4.074a177.5 177.5 0 0 1-4.324-.774Zm0 0"
        />
      </G>
      <G id="aB" clipPath="url(#y)">
        <Path
          style={{
            stroke: "none",
            fillRule: "nonzero",
            fill: "#000",
            fillOpacity: 1,
          }}
          d="m235.277 96.648 3.875.415-3.379 31.624-3.875-.414Zm0 0"
        />
      </G>
      <G id="aD" clipPath="url(#z)">
        <Path
          style={{
            stroke: "none",
            fillRule: "nonzero",
            fill: "#000",
            fillOpacity: 1,
          }}
          d="m239.285 97.254-.27 2.535a5.846 5.846 0 0 1-7.421-.797l.273-2.535Zm0 0"
        />
      </G>
      <G id="aF" clipPath="url(#A)">
        <Path
          style={{
            stroke: "none",
            fillRule: "nonzero",
            fill: "#000",
            fillOpacity: 1,
          }}
          d="M241.625 95.227a5.842 5.842 0 0 1-6.43 5.18l1.243-11.618a5.838 5.838 0 0 1 5.187 6.438Zm0 0"
        />
      </G>
      <G id="aH" clipPath="url(#B)">
        <Path
          style={{
            stroke: "none",
            fillRule: "nonzero",
            fill: "#000",
            fillOpacity: 1,
          }}
          d="m261.637 123.813-4.067 6.601-3.898-3.387 5.726-5.992Zm0 0"
        />
      </G>
      <G id="aJ" clipPath="url(#C)">
        <Path
          style={{
            stroke: "none",
            fillRule: "nonzero",
            fill: "#000",
            fillOpacity: 1,
          }}
          d="M29.723 201.824s16.664 16.668 7.257 41.399c-9.41 24.734 16.137 65.867 16.137 65.867s-.273-.043-.793-.13c-34.226-6.042-51.23-45.21-32.199-74.292 7.074-10.8 12.883-23.508 9.598-32.844Zm0 0"
        />
      </G>
      <G id="aL" clipPath="url(#D)">
        <Path
          style={{
            stroke: "none",
            fillRule: "nonzero",
            fill: "#000",
            fillOpacity: 1,
          }}
          d="M379.438 270.262c-10.079.078-23.415-1.57-26.098-3.188-2.043-1.25-2.86-5.715-3.133-7.777h-.297s.567 7.2 3.25 8.836c2.684 1.637 16.02 3.285 26.098 3.187 2.906-.023 3.91-1.058 3.86-2.59-.407.934-1.516 1.508-3.68 1.532Zm0 0"
        />
      </G>
      <G id="aN" clipPath="url(#E)">
        <Path
          style={{
            stroke: "none",
            fillRule: "nonzero",
            fill: "#000",
            fillOpacity: 1,
          }}
          d="M19.184 313.95c16.976 2.995 39.937 3.984 44.93 1.991 3.804-1.523 6.445-8.828 7.488-12.23l.496.101s-2.996 11.985-7.985 13.981c-4.992 1.996-27.957 1-44.93-1.992-4.898-.863-6.3-2.895-5.773-5.465.414 1.664 2.125 2.957 5.774 3.613Zm0 0"
        />
      </G>
      <LinearGradient
        id="H"
        gradientUnits="userSpaceOnUse"
        x1={660.62}
        y1={785.23}
        x2={660.62}
        y2={108.23}
        gradientTransform="matrix(.39606 .04234 -.04233 .39615 -5.955 -31.02)"
      >
        <Stop
          offset={0}
          style={{
            stopColor: "gray",
            stopOpacity: 0.25098,
          }}
        />
        <Stop
          offset={0.54}
          style={{
            stopColor: "gray",
            stopOpacity: 0.121569,
          }}
        />
        <Stop
          offset={1}
          style={{
            stopColor: "gray",
            stopOpacity: 0.101961,
          }}
        />
      </LinearGradient>
      <LinearGradient
        id="Y"
        gradientUnits="userSpaceOnUse"
        x1={636.28}
        y1={829.65}
        x2={636.28}
        y2={226.73}
        gradientTransform="matrix(.38636 .01992 -.01992 .3984 -5.46 -16.016)"
      >
        <Stop
          offset={0}
          style={{
            stopColor: "gray",
            stopOpacity: 0.25098,
          }}
        />
        <Stop
          offset={0.54}
          style={{
            stopColor: "gray",
            stopOpacity: 0.121569,
          }}
        />
        <Stop
          offset={1}
          style={{
            stopColor: "gray",
            stopOpacity: 0.101961,
          }}
        />
      </LinearGradient>
    </Defs>
    <Use xlinkHref="#F" mask="url(#G)" />
    <Path
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "url(#H)",
      }}
      d="M293.738 308.164c.645-8.851.45-15.64-.398-16.336-.356-.297-.688-1.375-.95-2.508.903-.68 1.391-1.472 1.173-2.39-1.063-4.422-17.825-36.98-20.52-37.575-2.695-.593-2.137-48.84-2.137-48.84l3.934-36.804h-.055c.32-1.992.863-3.945 1.621-5.816.153-.372.309-.73.469-1.083 3.258.114 6.375-1.332 9.066-5.136a368.676 368.676 0 0 1 8.125-11.059c5.832-4.543 13.008-11.554 15.094-19.687 3.684-14.375-13.144-29.082-13.144-29.082l-5.239-3.528c-.07-.199-.129-.398-.183-.597a16.04 16.04 0 0 1-.149-.582c1.211-.141 2.399-.418 3.551-.82a3.64 3.64 0 0 0 3.582.308l.074-.04c.196-.05.387-.116.57-.198.571-.313 1.114-.68 1.618-1.098 2.047-1.504 4.492-2.336 6.726-3.54 3.805-2.046 7.125-5.413 8.094-9.632.27-1.367.414-2.754.434-4.148a8.07 8.07 0 0 0-.246-2.996c-.266-.766-.754-1.43-1.063-2.18-.664-1.625-.394-3.457-.433-5.215-.047-3.312-1.196-6.66-3.512-9.027-2.317-2.371-5.79-3.645-9.016-2.953-.863.199-1.707.464-2.531.796-.371.137-.738.278-1.106.399-1.445.527-2.886.933-4.378.586-1.79-.418-3.348-1.922-5.18-1.707-.383.05-.754.164-1.098.336-.66.21-1.273.535-1.82.957a21.066 21.066 0 0 0-2.348 1.941c-.93.899-1.824 1.973-1.953 3.262a4.023 4.023 0 0 0 1.02 2.933A16.85 16.85 0 0 0 274 78.902c-.031.184-.066.371-.102.559a40.3 40.3 0 0 1-.996 4.176c.012-.258.051-.508.118-.758-.266-.059-.543-.11-.825-.16h-.129c-.25-.043-.5-.078-.753-.11h-.067c-3.828-.484-8.5-.054-11.152 1.461a22.788 22.788 0 0 0-9.676 11.024 27.37 27.37 0 0 0-6.29 9.96 13.645 13.645 0 0 0-6.276-1.3c-3.227-6.371-9.329-14.317-17.325-5.828-8.418 8.937 1.918 11.554 9.004 12.324.235.82.602 1.594 1.086 2.293.512.777 1.074 1.52 1.684 2.227-.227.07-.469.082-.703.035-1.63-.457-1.508 16.191 5.777 21.047a41.05 41.05 0 0 1-4.676 8.578 48.112 48.112 0 0 0-6.265 12.465c-.754 2.316-1.293 4.52-1.141 5.777.016.144.047.285.09.426a1.126 1.126 0 0 0 .152.32c.031.039.067.078.106.113.035.035.074.063.113.09a.807.807 0 0 0 .133.059c.047.011.093.023.144.027h.024c.054.004.105.004.16 0h.031c.059-.004.117-.012.176-.023h.039l.18-.047h.058l.184-.075.078-.03.2-.095.089-.046.227-.13.082-.046.285-.18.054-.035.364-.262a35.64 35.64 0 0 1-1.223 2.2c-2.305 3.761-6.086 8.12-11.664 9.347-10.355 2.274-37.008 36.348-37.008 36.348s-8.215-.57-4.887 25.629c3.333 26.199 3.961 40.418 3.961 40.418l.145.09c-3.121 3.554-9.488 9.937-15.027 10.011-7.68.106-12.204 5.156-8.555 8.317 3.648 3.156 43.414-1.817 43.414-1.817s.266-10.394-1.629-15.172c.32-.28.617-.582.895-.906l-1.965-52.543s24.828-21.289 36.933-23.351c-.082-.043-.16-.082-.238-.125a8.682 8.682 0 0 1 2.316-.043c10.579 1.437 18.61 49.675 18.61 49.675s1.945 7.594 7.762 13.45c5.816 5.851 18.722 28.46 18.722 28.46l.535-.062.075.125c0 3.426-.524 8.57-3.188 12.582-4.383 6.606 7.914 9.164 7.914 9.164s8.942 2.48 9.578-6.37Zm0 0"
    />
    <Path
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#444176",
        fillOpacity: 1,
      }}
      d="M181.3 274.586s-9.253 12.164-16.91 12.27c-7.656.109-12.167 5.124-8.527 8.265 3.64 3.137 43.313-1.793 43.313-1.793s.375-14.95-3.059-17.133c-3.433-2.183-14.816-1.61-14.816-1.61ZM280.66 289.188s1.418 9.632-2.957 16.203c-4.371 6.57 7.895 9.105 7.895 9.105s8.91 2.48 9.558-6.32c.653-8.801.442-15.54-.398-16.254-.836-.719-1.531-5.672-1.531-5.672Zm0 0"
    />
    <Path
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#565387",
        fillOpacity: 1,
      }}
      d="M280.27 292.832s-12.891-22.484-18.688-28.285c-5.8-5.8-7.75-13.371-7.75-13.371s-8.02-47.965-18.574-49.403c-10.551-1.437-39.496 23.309-39.496 23.309l2.062 52.223c-6.281 7.28-18.601-.465-18.601-.465s-.637-14.164-3.957-40.219c-3.32-26.05 4.863-25.496 4.863-25.496s26.555-33.863 36.887-36.129c5.578-1.215 9.328-5.547 11.629-9.285a30.511 30.511 0 0 0 2.851-5.977l44.145 4.723-3.91 36.594s-.543 47.965 2.148 48.558c2.695.594 19.414 32.973 20.473 37.368 1.062 4.394-14.082 5.855-14.082 5.855Zm0 0"
    />
    <Use xlinkHref="#I" mask="url(#J)" />
    <Path
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#ffbec7",
        fillOpacity: 1,
      }}
      d="M301.813 102.719s-41.747-1.406-34.114-7.012c4.707-3.46 6.742-10.23 7.613-14.91.317-1.656.528-3.328.63-5.008 0 0 22.253-2.207 16.78 6.074-1.433 2.176-1.492 4.64-.796 7.098 1.965 6.914 9.887 13.758 9.887 13.758Zm0 0"
    />
    <Path
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#dfe5ee",
        fillOpacity: 1,
      }}
      d="M256.402 92.664s-10.101 5.648-12.093 18.59c-1.993 12.941-3.63-.399-3.63-.399s-5.784 5.497-7.566 5.004c-1.781-.496-1.465 19.418 8.051 21.97 9.516 2.546 17.031-39.169 17.031-39.169Zm0 0"
    />
    <Use xlinkHref="#K" mask="url(#L)" />
    <Path
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#ffbec7",
        fillOpacity: 1,
      }}
      d="M241.918 110.996s-7.758-24.703-19.828-11.91c-12.067 12.793 14.558 12.57 14.558 12.57Zm0 0"
    />
    <Use xlinkHref="#M" mask="url(#N)" />
    <Path
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#ffbec7",
        fillOpacity: 1,
      }}
      d="M292.203 55.2c9.145 1.32 15.485 9.804 14.164 18.948-1.32 9.145-9.805 15.485-18.945 14.165-9.145-1.32-15.485-9.805-14.164-18.95 1.32-9.144 9.805-15.484 18.945-14.164Zm0 0"
    />
    <Use xlinkHref="#O" mask="url(#P)" />
    <Path
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#dfe5ee",
        fillOpacity: 1,
      }}
      d="M310.457 122c-2.227 8.672-10.285 16.043-16.273 20.5a67.793 67.793 0 0 1-6.895 4.55s-6.203 3.614-9.484 11.688a27.403 27.403 0 0 0-1.993 9.723s-38.328-10.524-45.957-4.918c-4.011 2.95-3.378-1.219-1.87-5.832a47.757 47.757 0 0 1 6.238-12.39c2.109-3.032 4.754-7.473 5.55-11.614 1.055-5.496 8.22-26.41 11.551-35.973a22.794 22.794 0 0 1 10.203-12.394c3.094-1.746 8.875-2.04 12.907-1.149 0 0-1.297 4.32 4.668 5.094.644.086 1.285.2 1.921.348 2.387.562 8.278 1.68 10.891-.207l5.422 3.636s16.789 14.645 13.121 28.938Zm0 0"
    />
    <Use xlinkHref="#Q" mask="url(#R)" />
    <Path
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#88455e",
        fillOpacity: 1,
      }}
      d="M293.023 61.8a5.997 5.997 0 0 0-2.027-1.28l-3.637-1.649a12.668 12.668 0 0 1-3.382-1.992c-.973-.883-1.672-2.164-1.54-3.465.13-1.305 1.02-2.352 1.95-3.238a20.162 20.162 0 0 1 2.34-1.934A5.09 5.09 0 0 1 289 47.2c1.82-.215 3.375 1.278 5.156 1.696 2.692.628 5.278-1.23 7.969-1.805 3.219-.684 6.695.582 8.988 2.937 2.297 2.356 3.457 5.684 3.508 8.977.027 1.75-.23 3.586.434 5.18.3.742.797 1.406 1.054 2.168.27.968.352 1.976.246 2.976a22.541 22.541 0 0 1-.43 4.129c-.964 4.195-4.277 7.54-8.07 9.563-2.23 1.195-4.668 2.023-6.707 3.515-.496.414-1.027.778-1.593 1.09a3.634 3.634 0 0 1-3.559-.309 2.591 2.591 0 0 1-1.195-2.148c.039-.856.613-1.574 1.054-2.305 1.157-1.898 1.426-4.593-.113-6.207-.672-.703-1.594-1.12-2.258-1.84-1.066-1.195-1.195-2.918-1.23-4.511-.102-2.977-.61-5.782.633-8.485"
    />
    <Use xlinkHref="#S" mask="url(#T)" />
    <Use xlinkHref="#U" mask="url(#V)" />
    <Use xlinkHref="#W" mask="url(#X)" />
    <Path
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "url(#Y)",
      }}
      d="m296.09 282.75-6.422-27.738c-2.738-4.551-5.555-7-7.918-8.301-3.043-1.875-5.465-1.86-6.23-1.793l-.86-.91c-3.273-4.625-5.012-16.73-5.012-16.73-.168-5.68-3.765-9.524-8.394-12.122-7.8-4.672-18.984-5.578-21.363-5.715l-1.895-3.773-.512-.125-.117-.238c-.398-.11-.847-.2-1.281-.285l3.351-68.844.032-.664 13.246.644a4.01 4.01 0 0 0 4.047-3.812 4.01 4.01 0 0 0-3.649-4.196l-15.508-.753v-.336l1.45-29.746v-.333a6.08 6.08 0 0 0 2.328-4.52 5.843 5.843 0 0 0-2.625-5.272 5.825 5.825 0 0 0-9.008 4.707 6.083 6.083 0 0 0 1.879 4.722v.332l-1.461 29.75v.336l-15.52-.734a4.01 4.01 0 0 0-4.05 3.812 4.01 4.01 0 0 0 3.652 4.196l12.598.613-.032.668-3.398 69.719a92.262 92.262 0 0 0-14.395 2.992l-5.48 19.46-16.008 2.903-8.344 18.324-7.773 13.637a50.77 50.77 0 0 0-2.39.957c-28.977 12.23-30.153 42.606-30.153 42.606 8.074 13.769 48.848 7.734 48.848 7.734 23.27 20.863 69.52 8.738 69.52 8.738 11.152 2.75 19.98 3.942 26.94 4.207 19.415.742 24.297-5.722 24.297-5.722 6.989-17.723-12.39-38.395-12.39-38.395Zm0 0"
    />
    <Path
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#e417c3",
        fillOpacity: 1,
      }}
      d="m228.129 131.3 3.723-34.85 7.425.792-3.726 34.852Zm0 0"
    />
    <Path
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#f0f5fa",
        fillOpacity: 1,
      }}
      d="m216.672 211.023 8.344-78.097 12.582 1.347-8.344 78.094Zm0 0"
    />
    <Use xlinkHref="#Z" mask="url(#aa)" />
    <Use xlinkHref="#ab" mask="url(#ac)" />
    <Use xlinkHref="#ad" mask="url(#ae)" />
    <Path
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#e417c3",
        fillOpacity: 1,
      }}
      d="m213.004 126.414 38.39 4.106a3.893 3.893 0 1 1-.828 7.742l-38.39-4.102a3.896 3.896 0 0 1 .828-7.746Zm0 0"
    />
    <Path
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#a8a8a8",
        fillOpacity: 1,
      }}
      d="M140.773 307.383s-.324-31.156 30.497-43.824l7.14-13.63 7.461-18.175 15.902-3.586 4.54-19.145s17.527-6.168 28.878-3.898l2.27 3.898s29.207-.324 30.5 15.575c0 0 2.918 14.605 7.137 17.203 0 0 7.14-1.621 14.277 8.765l7.785 26.614s20.442 19.148 14.277 36.672c0 0-8.437 12.007-51.265 3.898 0 0-45.754 13.945-70.106-5.18.028.004-40.53 7.793-49.293-5.187Zm0 0"
    />
    <Use xlinkHref="#af" mask="url(#ag)" />
    <Use xlinkHref="#ah" mask="url(#ai)" />
    <Use xlinkHref="#aj" mask="url(#ak)" />
    <Use xlinkHref="#al" mask="url(#am)" />
    <Use xlinkHref="#an" mask="url(#ao)" />
    <Use xlinkHref="#ap" mask="url(#aq)" />
    <Use xlinkHref="#ar" mask="url(#as)" />
    <Use xlinkHref="#at" mask="url(#au)" />
    <Use xlinkHref="#av" mask="url(#aw)" />
    <Use xlinkHref="#ax" mask="url(#ay)" />
    <Use xlinkHref="#az" mask="url(#aA)" />
    <Use xlinkHref="#aB" mask="url(#aC)" />
    <Use xlinkHref="#aD" mask="url(#aE)" />
    <Path
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#e417c3",
        fillOpacity: 1,
      }}
      d="M236.426 88.781a5.846 5.846 0 0 1 5.187 6.43 5.843 5.843 0 0 1-6.43 5.187 5.843 5.843 0 0 1 1.243-11.617Zm0 0"
    />
    <Use xlinkHref="#aF" mask="url(#aG)" />
    <Path
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#ffbec7",
        fillOpacity: 1,
      }}
      d="m261.637 123.813-4.07 6.601-3.899-3.383-5.336-4.636s-9.871.796-16.187-8.766c-2.708-4.094-.602-6.434 2.683-7.77a13.64 13.64 0 0 1 15.7 4.184Zm0 0"
    />
    <Use xlinkHref="#aH" mask="url(#aI)" />
    <Path
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#dfe5ee",
        fillOpacity: 1,
      }}
      d="m284.004 121.867-5.734 12.285-17.63-12.59-10.316 10.829s23.668 38.93 37.004 20.164c8.09-11.399 14.606-19.332 18.473-23.809a13.42 13.42 0 0 0 2.258-14.14c-1.22-2.79-3.336-4.961-7.004-4.63l-.278.028a20.71 20.71 0 0 0-16.773 11.863Zm0 0"
    />
    <Path
      style={{
        fill: "none",
        strokeWidth: 2,
        strokeLinecap: "butt",
        strokeLinejoin: "miter",
        stroke: "#535461",
        strokeOpacity: 1,
        strokeMiterlimit: 10,
      }}
      d="M985.83 672.353s-13.26-45.004 2.49-78.144a71.107 71.107 0 0 0 5.747-44.602 119.846 119.846 0 0 0-6.306-20.924"
      transform="matrix(.39831 0 0 .3984 -26.544 -4.773)"
    />
    <Path
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#e417c3",
        fillOpacity: 1,
      }}
      d="M370.79 197.512c0 2.199-3.985 8.57-3.985 8.57s-3.98-6.375-3.98-8.57a3.983 3.983 0 1 1 7.964 0ZM377.371 209.684c-1.195 1.843-8 5.03-8 5.03s.125-7.515 1.32-9.359a3.978 3.978 0 0 1 5.407-1.027 3.987 3.987 0 0 1 1.273 5.356ZM377.078 230.488c-1.96.989-9.441.305-9.441.305s3.898-6.422 5.86-7.41a3.979 3.979 0 0 1 4.077.113 3.992 3.992 0 0 1 1.84 3.645 3.993 3.993 0 0 1-2.336 3.351ZM373.32 246.18c-1.77 1.308-9.257 1.898-9.257 1.898s2.757-6.988 4.523-8.297a3.987 3.987 0 0 1 6.488 2.7 3.988 3.988 0 0 1-1.754 3.699ZM361.016 215.145c1.593 1.53 8.918 3.12 8.918 3.12s-1.797-7.296-3.375-8.824a3.98 3.98 0 0 0-6.805 1.793 3.98 3.98 0 0 0 1.262 3.91ZM356.852 233.547c1.964.988 9.445.308 9.445.308s-3.899-6.421-5.86-7.41a3.984 3.984 0 1 0-3.586 7.105ZM355.254 251.992c1.77 1.309 9.258 1.899 9.258 1.899s-2.758-6.989-4.524-8.297a3.985 3.985 0 0 0-4.734 6.398ZM29.723 201.547s16.664 16.668 7.257 41.402c-9.41 24.735 16.137 65.863 16.137 65.863s-.273-.039-.793-.125c-34.23-6.046-51.234-45.195-32.203-74.285 7.078-10.816 12.887-23.5 9.602-32.855Zm0 0"
    />
    <Use xlinkHref="#aJ" mask="url(#aK)" />
    <Path
      style={{
        fill: "none",
        strokeWidth: 1,
        strokeLinecap: "butt",
        strokeLinejoin: "miter",
        stroke: "#535461",
        strokeOpacity: 1,
        strokeMiterlimit: 10,
      }}
      d="M141.261 517.868s23.616 51.28 0 93.126c-23.625 41.837-4 159.25 58.705 176.114"
      transform="matrix(.39831 0 0 .3984 -26.544 -4.773)"
    />
    <Path
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#e417c3",
        fillOpacity: 1,
      }}
      d="M.043 268.96s19.016-3.026 20.75 14.017c1.73 17.043 36.562 19.418 36.562 19.418l-.652.425C27.945 321.707.45 314.848 4.598 289.773c1.52-9.32 1.414-18.68-4.555-20.812Zm0 0"
    />
    <Path
      style={{
        fill: "none",
        strokeWidth: 1,
        strokeLinecap: "butt",
        strokeLinejoin: "miter",
        stroke: "#535461",
        strokeOpacity: 1,
        strokeMiterlimit: 10,
      }}
      d="M66.748 687.08s37.06 8.128 34 41.827c-3.06 33.699 55.037 74.095 109.888 42.092"
      transform="matrix(.39831 0 0 .3984 -26.544 -4.773)"
    />
    <Path
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#a8a8a8",
        fillOpacity: 1,
      }}
      d="M349.91 259.29s8.926-.278 11.613-2.192c2.692-1.918 13.73-4.203 14.395-1.133.668 3.07 13.414 15.277 3.34 15.363-10.074.082-23.414-1.57-26.098-3.187-2.683-1.618-3.25-8.852-3.25-8.852Zm0 0"
    />
    <Use xlinkHref="#aL" mask="url(#aM)" />
    <Path
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#a8a8a8",
        fillOpacity: 1,
      }}
      d="M72.102 303.805s-14.98-3.004-18.985-6.989c-4-3.984-21.965-10.984-23.96-5.976-1.997 5.008-26.95 21.953-9.973 24.95 16.976 2.995 39.937 3.983 44.93 1.991 4.988-1.992 7.988-13.976 7.988-13.976Zm0 0"
    />
    <Use xlinkHref="#aN" mask="url(#aO)" />
  </Svg>
)

export default SvgComponent
